﻿{
  "createAccount": "Créer un compte",
  "subscription": "Abonnement",
  "oneTimePurchase": "Achat unique",
  "billingDetails": "Informations de facturation",
  "paymentDetails": "Informations sur le paiement",
  "requestAQuote": "Formulaire de demande de l’organisation",
  "reviewOrder": "Vérifier la commande",
  "thankYouForYourOrder": "Nous vous remercions pour votre commande !",
  "joinTheCommunity": "Rejoignez la communauté",
  "startTrial": "Commencer l'essai",
  "yourTrialHasEnded": "Votre période d’essai est terminée",
  "taxExempt": "Exonération de taxes",
  "taxExemptThankYou": "Téléchargement réussi !",
  "planDetails": "Détails de ma souscription",
  "modifyPlan": "Modifier le forfait",
  "modifyPaymentDetails": "Modifier les informations de paiement",
  "redirect": "Redirection vers Boardmaker",
  "perpetualTrial": "Téléchargez votre essai gratuit de {{trialLength}} jours",
  "perpetualThankYou": "Votre logiciel est prêt !",
  "downloads": "Télécharger Boardmaker",
  "partner": "Trouver un partenaire",
  "intro": "Sélectionnez un produit Boardmaker ci-dessous pour télécharger la dernière version prise en charge par votre dispositif.",
"systemRequirements": "Système nécessaire",
"releaseNotes": "Notes de publication",
"comparison": "Rapprocher abonnement et licence"
}
